import { Capacitor } from "@capacitor/core";
import { App } from "@capacitor/app";
import { Keyboard, KeyboardResize } from "@capacitor/keyboard";
import { SplashScreen } from "@capacitor/splash-screen";
import { StatusBar, Style } from "@capacitor/status-bar";
import { initializeMobilePush } from "./services/mobilePush";

if (Capacitor.isNativePlatform()) {
  document.documentElement.classList.add("capacitor");
  App.addListener("appUrlOpen", ({ url }) => {
    const incoming = new URL(url);
    if (
      ["observertheory.com", "www.observertheory.com"].includes(
        incoming.hostname,
      )
    ) {
      window.location.assign(
        `${incoming.pathname}${incoming.search}${incoming.hash}`,
      );
    }
  });
  App.addListener("backButton", ({ canGoBack }) =>
    canGoBack ? window.history.back() : App.minimizeApp(),
  );
  Keyboard.setResizeMode({ mode: KeyboardResize.Native }).catch(
    () => undefined,
  );
  StatusBar.setStyle({ style: Style.Light }).catch(() => undefined);
  SplashScreen.hide().catch(() => undefined);
  initializeMobilePush().catch(() => undefined);
}
